export default __webpack_public_path__ + "images/SV.1c7cf21.png";